import React from 'react';
import MapBlock from './map-block';
import BudgetBlock from './budget-block';

const App = () =>
  <div id="app">
    <MapBlock />
    <BudgetBlock />
    <div className="note-block">
      <div className="note-items">
        <div className="note">
          <p className="title">行政院主計總處  |  104年度直轄市及縣市總預算彙編</p>
          <p className="link"><a target="_blank" href="http://www.dgbas.gov.tw/public/Attachment/5611134554Q5ISNJPV.xls">
          http://www.dgbas.gov.tw/public/Attachment/5611134554Q5ISNJPV.xls</a>
          </p>
        </div>
        <div className="note">
          <p className="title">內政部統計處  |  104年土地與人口概況</p>
          <p className="link">
            <a target="_blank" href="http://statis.moi.gov.tw/micst/stmain.jsp?sys=220&ym=9900&ymt=10400&kind=21&type=1&funid=c0110201&cycle=4&outmode=0&compmode=0&outkind=1&fldlst=1111&codspc0=1,1,3,2,6,1,9,1,12,1,15,16,&rdm=y5bpallh">
            http://statis.moi.gov.tw/micst/stmain.jsp?sys=220&ym=9900&ymt=10400&kind=21&type=1&funid=c0110201&cycle=4&outmode=0&compmode=0&outkind=1&fldlst=1111&codspc0=1,1,3,2,6,1,9,1,12,1,15,16,&rdm=y5bpallh</a>
          </p>
        </div>
        <div className="note">
          <p className="title">中華民國統計資訊網  |  104年縣市土地面積</p>
          <p className="link">
            <a target="_blank" href="http://statdb.dgbas.gov.tw/pxweb/Dialog/statfile9.asp">
            http://statdb.dgbas.gov.tw/pxweb/Dialog/statfile9.asp</a>
          </p>
        </div>
      </div>
    </div>
  </div>;

export default App;



/** WEBPACK FOOTER **
 ** ./src/components/app.js
 **/